import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("polla_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// --- Auto-logout on 401 ---------------------------------------------------
// If a request returns 401 AND we believed we were authenticated (a token was
// stored), the token is stale (server rotated JWT_SECRET, account disabled,
// expired token, etc.). Clear it and bounce the user to /login so their
// subsequent edits aren't silently lost. Guarded with a flag so a burst of
// concurrent 401s only shows one toast / one redirect.
let unauthorizedHandled = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Don't auto-logout when the user is actively trying to log in / register —
    // those endpoints can legitimately return 401 / 423 on wrong credentials,
    // and the page already renders inline error messages.
    const isAuthAttempt = url.includes("/auth/login") || url.includes("/auth/2fa/login") || url.includes("/auth/register");
    if (status === 401 && !isAuthAttempt) {
      const hadToken = !!localStorage.getItem("polla_token");
      if (hadToken && !unauthorizedHandled) {
        unauthorizedHandled = true;
        localStorage.removeItem("polla_token");
        try {
          toast.error("Tu sesión expiró. Por favor inicia sesión de nuevo.");
        } catch {
          // Toast not ready yet (e.g. error fires before SonnerProvider mounts).
          // Silently fall through — the redirect below will reload the app.
        }
        // Small delay so the user sees the toast before the hard nav.
        setTimeout(() => {
          // Hard navigate so all in-flight requests are dropped and the app
          // boots fresh on /login.
          window.location.replace("/login");
        }, 600);
      }
    }
    return Promise.reject(error);
  }
);

export const flagUrl = (code) => `https://flagcdn.com/w80/${code}.png`;
